<script>
  export let setSideBar;
  let isShowing = false;
  let timeout;
  import { onDestroy, onMount } from "svelte";
  import * as PropTypes from "prop-types";
  import { logout } from "@/api";
  import profileStore from "@/stores/profile";
  import SvgWrapper from "@/components/atoms/SvgWrapper.svelte";
  import { INSTALL_REFERRER } from "@/constants/constants";
  import Modal from "@/components/molecules/Modal.svelte";
  import SvgClose from "$assets/svg/close.svg?src";
  import SvgArrowUp from "$assets/svg/arrow-up.svg?src";
  import MojLogoWhite from "$assets/png/Moj_logo_2@2x.png";
  import trackEvents, { getCommonEventData } from "@/events";
  import * as css from "@/utils/css";
  import { linksOnSideBar, redirectSidebarLinks } from "@/utils";
  import * as utils from "@/utils/helpers/utils";
  import InstallButton from "./InstallButton.svelte";
  import { goto } from "$app/navigation";
  import { isWebView } from "@/utils/helpers/utils";

  const { checkPropTypes, func } = PropTypes;
  let showBanner = false;
  const propTypes = {
    setSideBar: func,
  };

  const closeSideBar = () => {
    isShowing = false;
    timeout = setTimeout(() => {
      setSideBar(false);
    }, 200);
  };

  const onInnerTap = (e) => e.stopPropagation();

  onMount(() => {
    showBanner = utils.isMobile();
    checkPropTypes(propTypes, $$props, "prop", "SideBar");
    isShowing = true;
  });

  onDestroy(() => {
    clearTimeout(timeout);
  });

  const trackOnSidebarClick = (referrer) => {
    const data = getCommonEventData();
    trackEvents("clickingInSidepaneweb", {
      ...data,
      referrerComponent: referrer,
      userType: $profileStore.isTempAuth ? "temp user" : "logged-in user",
    });
  };

  const handleAccountDelete = () => {
    const isDeleteInitiated = !isWebView();
    profileStore.updateState({ isDeleteInitiated });
    goto("request-account-delete");
  };
</script>

<Modal
  Bgc="bg-transparent"
  ZIndex="z-[100]"
  fullScreen
  _onCloseHandler={closeSideBar}
>
  <div
    class={`bg-light-black w-4/5 max-w-[304px] h-full trs-slider overflow-auto ${
      isShowing ? "translate-x-0" : "-translate-x-full"
    }`}
    on:click={onInnerTap}
    on:touchstart={(e) => e.stopPropagation()}
    on:mousedown={(e) => e.stopPropagation()}
  >
    <div
      class={`bg-bg-primary-moj text-white ${css.verCenteredChild} justify-between p-md`}
      data-testid="sidebar"
    >
      <div class={css.verCenteredChild}>
        <img
          class="w-5xl inline-block fitcover_object-contain avatar_h-full"
          src={MojLogoWhite}
          alt="Moj -Indian app"
        />
      </div>
      <div data-testid="sidebar-close-button">
        <div class="cursor-pointer" on:click={closeSideBar}>
          <SvgWrapper className="h-mmd w-mmd text-white" svg={SvgClose} />
        </div>
      </div>
    </div>

    <div
      class="flex flex-col justify-between h-[89%]"
      data-testid="sidebar-items"
    >
      <div>
        {#each linksOnSideBar as item, i}
          <a
            key={i}
            class={`no-underline p-md text-white ${css.verCenteredChild} justify-between`}
            href={`https://help.mojapp.in/${item.l}`}
            target="_blank"
          >
            <div>{item.n}</div>
            <SvgWrapper className="w-mdd h-mdd rotate-90" svg={SvgArrowUp} />
          </a>
        {/each}
        {#each redirectSidebarLinks as item, i}
          <a
            key={i}
            class={`no-underline p-md text-white ${css.verCenteredChild} justify-between`}
            href={`${item.l}`}
            on:click={() => trackOnSidebarClick("wallet")}
            data-testid="wallet_btn"
          >
            <div>{item.n}</div>
            {#if item.new}
              <div class="float-right text-smd font-bold text-parrot-green">
                New
              </div>
            {/if}
          </a>
        {/each}
        {#if $profileStore.isAuth}
          <span
            class={`no-underline p-md text-white ${css.verCenteredChild} justify-between`}
            on:click={async () => {
              await logout();
              closeSideBar();
            }}
            data-testid="logout"
          >
            <div>Logout</div>
          </span>
          <span
            class={`no-underline p-md text-white ${css.verCenteredChild} justify-between`}
            on:click={handleAccountDelete}
          >
            <span>Delete Account</span>
          </span>
        {:else}
          <a
            class={`no-underline p-md text-white ${css.verCenteredChild} justify-between`}
            href="login"
            on:click={() => trackOnSidebarClick("login")}
          >
            <div>Login</div>
          </a>
        {/if}
      </div>
      {#if showBanner}
        <InstallButton
          style="h-[44px] bg-brand-yellow rounded-lg text-black font-bold text-base py-[10px] mx-[10px] text-center cursor-pointer"
          label="Install App"
          source={INSTALL_REFERRER.SIDEBAR}
          referrer={INSTALL_REFERRER.SIDEBAR}
        />
      {/if}
    </div>
  </div>
</Modal>

<style></style>
